@if (date) {
  {{date | localizedDate:'E, dd.MM.yyyy' }}
}
